<div *ngIf="sessionData" class="ApiKeys">
  <div class="ApiKeys-header d-flex flex-row">
    <div class="flex-grow-1">
      <h4 class="title__page">API Keys</h4>
      <p class="mb-0 text-muted">
        Manage long-lived keys for third-party integrations. Keys are scoped to your account permissions.
        Third-party access is restricted to platform IP whitelist configured by your administrator.
      </p>
    </div>
    <div class="flex-grow-0">
      <app-button
        [color]="cancelButtonProperties.color"
        [route]="cancelButtonProperties.route"
        [style]="cancelButtonProperties.style"
        [size]="cancelButtonProperties.size"
        [text]="cancelButtonProperties.text"></app-button>
    </div>
  </div>

  <div class="ApiKeys-body">
    <div *ngIf="!canCreateApiKeys" class="alert alert-info mb-4">
      API key creation is not enabled for your account. Contact your administrator to enable it.
    </div>

    <div *ngIf="showCreateMySpaceScoutKey" class="ApiKeys-form mb-4">
      <h6 class="title__page">My Space Scout</h6>
      <p class="text-muted mb-3">
        Create a single API key for the My Space Scout integration.
      </p>
      <app-button
        [Click]="createButtonProperties.onClick"
        [color]="createButtonProperties.color"
        [disabled]="createButtonProperties.observeApi"
        [size]="createButtonProperties.size"
        [style]="createButtonProperties.style"
        [text]="createButtonProperties.text"></app-button>
    </div>

    <div class="ApiKeys-list">
      <h6 class="title__page">Your API Keys</h6>
      <p *ngIf="loading" class="text-muted">Loading...</p>
      <p *ngIf="!loading && apiKeys.length === 0" class="text-muted">No API keys yet.</p>
      <div *ngIf="!loading && apiKeys.length > 0" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Key prefix</th>
              <th>Scope</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of apiKeys">
              <td>{{ key.name }}</td>
              <td><code>{{ key.key_prefix }}</code></td>
              <td>{{ key.scope }}</td>
              <td>{{ key.created_at }}</td>
              <td>
                <app-button
                  [Click]="onRevokeClick.bind(this, key)"
                  color="red"
                  size="small"
                  style="outline"
                  text="Revoke"></app-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
